/**************************************************
 * Nombre:       Barra
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import BarraPc from "./BarraPc";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import BarraCell from "./BarraCell";
import {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import {obtenerSeccion} from "../../Utilidades/obtenerSeccion";

const Barra = () => {
    const {masSM} = useResponsive()
    const location = useLocation()
    const [esRoja, setEsRoja] = useState(true)


    useEffect(() => {

        let secc = ['Detalle', 'Detalle_Sos', 'Sostenibilidad', 'Adicionales']
        let seccion = obtenerSeccion(location.pathname)
        if (secc.includes(seccion)) {
            setEsRoja(true)
        } else {
            setEsRoja(false)
        }

    }, [location]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            {masSM ?
                <BarraPc esRoja={esRoja}/>
                :
                <BarraCell esRoja={esRoja}/>
            }


        </Grid>
    )

}
export default Barra    